module.exports = __webpack_public_path__ + "static/media/avatar-accessibility.c7ed7931.svg";